export const hasOnlyNormalLetters = (fileName) => {
  const regex = /^[a-zA-Z0-9_.-]+$/; // Only allow letters, numbers, underscores, hyphens, and dots
  return regex.test(fileName);
};
